import { isEqual } from "lodash";

type AgentValues = { definition?: object | null };

function changedSince(current: object, saved: object): Record<string, unknown> {
  const savedEntries = new Map(Object.entries(saved));
  return Object.fromEntries(
    Object.entries(current).filter(
      ([key, value]) => !isEqual(value, savedEntries.get(key))
    )
  );
}

/**
 * The agent as the server now has it, with what the user changed since the
 * last save kept on top: a top-level field, or one setting of the definition.
 *
 * Measured against the last saved values, not the form's dirty flags: autosave
 * never clears those, so every field touched this session would read as
 * unsaved and overwrite a change Genie just made to it.
 */
export function keepUnsavedEdits<T extends AgentValues>(
  server: T,
  current: T,
  saved: T
): T {
  const { definition: currentDefinition, ...currentTop } = current;
  const { definition: savedDefinition, ...savedTop } = saved;
  return {
    ...server,
    ...changedSince(currentTop, savedTop),
    definition: {
      ...server.definition,
      ...changedSince(currentDefinition ?? {}, savedDefinition ?? {}),
    },
  };
}
